import produce from "immer";
import { useState } from "react";
import { CheckBox } from "../../../../helbest";
import DetailModal from "../../MyOrders/Item/DetailModal/DetailModal";
import styles from "./../Invoices.module.css";

const Row = (props) => {
  const {
    icon: Icon,
    invoice,
    checked,
    date,
    passed,
    setInvoiceList,
    invoiceIndex,
  } = props;

  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  const showDetails = () => {
    if (data) {
      setOpen(true);
    } else {
      fakeApiOrderData().then((response) => {
        if (response.code === 200) {
          setData(response.data);
          setTimeout(() => {
            setOpen(true);
          }, 500);
        }
      });
    }
  };

  return (
    <>
      <tr>
        <td>
          <div className={styles.InvoiceHeader}>
            <CheckBox
              checked={checked}
              onChange={(newValue) => {
                setInvoiceList(
                  produce((draft) => {
                    draft[invoiceIndex].checked = newValue.target.checked;
                  })
                );
              }}
            />
            <span onClick={showDetails}>{invoice}</span>
          </div>
        </td>
        <td>
          <div className={styles.InvoiceHeader}>{date}</div>
        </td>
        <td>
          <div className={styles.InvoiceHeader}>
            <div
              className={`${styles.StatusItem} ${
                passed ? styles.Passed : styles.Canceled
              }`}
            >
              <Icon className={passed ? styles.TickIcon : styles.CancelIcon} />
              <span>{passed ? "paid" : "Returned"}</span>
            </div>
          </div>
        </td>
      </tr>
      {data !== null && (
        <DetailModal open={open} setOpen={setOpen} data={data} />
      )}
    </>
  );
};

export default Row;

const fakeApiOrderData = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        code: 200,
        data: {
          id: 1233434,
          item_price: 68,
          service_fee: 20,
          credit_used: 0,
          discount: "10%",
          paid_amount: 99,
          name: `Lexus 5W-40 Fully Synthetic Motor Engine Oil (4L)`,
          quantity: "1",
          image: "/media/statics/images/80D26L-MF_65Ah_12V.png",
          order_date: "2022/04/06, 12:00",
        },
      });
    }, 1000);
  });
};
